export default "__VITE_ASSET__C$XRub6G__"